<div class="page-header">
  <h1 class="page-title">Person of interest</h1>
  <mat-divider></mat-divider>
</div>

<div class="table-container">
  <mat-toolbar>
    <a mat-flat-button
       color="accent"
       [routerLink]="['/person-of-interest/create']">
      <mat-icon class="mr-2"
                inline="true">add</mat-icon>Skapa
    </a>
  </mat-toolbar>
  <table mat-table
         [dataSource]="dataSource"
         class="table-hover"
         matSort
         matSortActive="id"
         matSortDirection="desc">

    <ng-container matColumnDef="id">
      <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header> ID. </th>
      <td mat-cell
          *matCellDef="let poi"> {{poi.id}} </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header> Namn </th>
      <td mat-cell
          *matCellDef="let poi"> {{poi.name}} </td>
    </ng-container>

    <ng-container matColumnDef="customer">
      <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header> Kund </th>
      <td mat-cell
          *matCellDef="let poi"> {{poi.customer?.name}} </td>
    </ng-container>

    <ng-container matColumnDef="media">
      <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header> Media </th>
      <td mat-cell
          *matCellDef="let poi">
        {{poi.media?.filename}}
        <!-- <img *ngIf="poi.media?.url"
             [src]="poi.media.url"
             alt="Bild för person {{poi.name}}" /> -->
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell
          *matHeaderCellDef
          class="actions-col"></th>
      <td mat-cell
          *matCellDef="let poi"
          [style.width]="'1px'">
        <button mat-icon-button
                (click)="onDeleteClick($event, poi)"
                class="delete-button"
                aria-label="delete item">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row
        *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row
        *matRowDef="let poi; columns: displayedColumns;"
        [routerLink]="['/person-of-interest', poi.id]"></tr>
  </table>
</div>
